/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    ApiUser,
    ApiUserFromJSON,
    ApiUserToJSON,
    ChangePasswordData,
    ChangePasswordDataFromJSON,
    ChangePasswordDataToJSON,
    ResetPasswordData,
    ResetPasswordDataFromJSON,
    ResetPasswordDataToJSON,
    UsersPage,
    UsersPageFromJSON,
    UsersPageToJSON,
} from '../models';

export interface ActivateUserRequest {
    userId: number;
}

export interface AddUserRequest {
    apiUser: ApiUser;
}

export interface ChangePasswordRequest {
    changePasswordData: ChangePasswordData;
}

export interface DeactivateUserRequest {
    userId: number;
}

export interface FindAllUsersRequest {
    page: number;
    size: number;
    includeInactive: boolean;
    query?: string;
}

export interface ForgotPasswordRequest {
    resetPasswordData: ResetPasswordData;
}

export interface Reset2faForUserRequest {
    userId: number;
}

export interface UnlockUserRequest {
    userId: number;
}

export interface UpdateUserRequest {
    apiUser: ApiUser;
}

/**
 * 
 */
export class UserApi extends runtime.BaseAPI {

    /**
     * Activates user
     */
    async activateUserRaw(requestParameters: ActivateUserRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiUser>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling activateUser.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/users/{userId}/active`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiUserFromJSON(jsonValue));
    }

    /**
     * Activates user
     */
    async activateUser(requestParameters: ActivateUserRequest, initOverrides?: RequestInit): Promise<ApiUser> {
        const response = await this.activateUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates new user
     */
    async addUserRaw(requestParameters: AddUserRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiUser>> {
        if (requestParameters.apiUser === null || requestParameters.apiUser === undefined) {
            throw new runtime.RequiredError('apiUser','Required parameter requestParameters.apiUser was null or undefined when calling addUser.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/users`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiUserToJSON(requestParameters.apiUser),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiUserFromJSON(jsonValue));
    }

    /**
     * Creates new user
     */
    async addUser(requestParameters: AddUserRequest, initOverrides?: RequestInit): Promise<ApiUser> {
        const response = await this.addUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * changes password for the user
     */
    async changePasswordRaw(requestParameters: ChangePasswordRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiUser>> {
        if (requestParameters.changePasswordData === null || requestParameters.changePasswordData === undefined) {
            throw new runtime.RequiredError('changePasswordData','Required parameter requestParameters.changePasswordData was null or undefined when calling changePassword.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/users/change-password`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChangePasswordDataToJSON(requestParameters.changePasswordData),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiUserFromJSON(jsonValue));
    }

    /**
     * changes password for the user
     */
    async changePassword(requestParameters: ChangePasswordRequest, initOverrides?: RequestInit): Promise<ApiUser> {
        const response = await this.changePasswordRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deactivates all users under this organisation
     */
    async deactivateAllUsersRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/users/deactivate-all`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deactivates all users under this organisation
     */
    async deactivateAllUsers(initOverrides?: RequestInit): Promise<void> {
        await this.deactivateAllUsersRaw(initOverrides);
    }

    /**
     * Deactivate user
     */
    async deactivateUserRaw(requestParameters: DeactivateUserRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiUser>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling deactivateUser.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/users/{userId}/active`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiUserFromJSON(jsonValue));
    }

    /**
     * Deactivate user
     */
    async deactivateUser(requestParameters: DeactivateUserRequest, initOverrides?: RequestInit): Promise<ApiUser> {
        const response = await this.deactivateUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches all users
     */
    async findAllUsersRaw(requestParameters: FindAllUsersRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<UsersPage>> {
        if (requestParameters.page === null || requestParameters.page === undefined) {
            throw new runtime.RequiredError('page','Required parameter requestParameters.page was null or undefined when calling findAllUsers.');
        }

        if (requestParameters.size === null || requestParameters.size === undefined) {
            throw new runtime.RequiredError('size','Required parameter requestParameters.size was null or undefined when calling findAllUsers.');
        }

        if (requestParameters.includeInactive === null || requestParameters.includeInactive === undefined) {
            throw new runtime.RequiredError('includeInactive','Required parameter requestParameters.includeInactive was null or undefined when calling findAllUsers.');
        }

        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        if (requestParameters.includeInactive !== undefined) {
            queryParameters['includeInactive'] = requestParameters.includeInactive;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/users`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UsersPageFromJSON(jsonValue));
    }

    /**
     * Fetches all users
     */
    async findAllUsers(requestParameters: FindAllUsersRequest, initOverrides?: RequestInit): Promise<UsersPage> {
        const response = await this.findAllUsersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * generates token to reset password without authentication
     */
    async forgotPasswordRaw(requestParameters: ForgotPasswordRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ResetPasswordData>> {
        if (requestParameters.resetPasswordData === null || requestParameters.resetPasswordData === undefined) {
            throw new runtime.RequiredError('resetPasswordData','Required parameter requestParameters.resetPasswordData was null or undefined when calling forgotPassword.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/users/forgot-password`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ResetPasswordDataToJSON(requestParameters.resetPasswordData),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResetPasswordDataFromJSON(jsonValue));
    }

    /**
     * generates token to reset password without authentication
     */
    async forgotPassword(requestParameters: ForgotPasswordRequest, initOverrides?: RequestInit): Promise<ResetPasswordData> {
        const response = await this.forgotPasswordRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Resets the 2fa configuration for user and unlocks their account
     */
    async reset2faForUserRaw(requestParameters: Reset2faForUserRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling reset2faForUser.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/users/{userId}/reset-2fa`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Resets the 2fa configuration for user and unlocks their account
     */
    async reset2faForUser(requestParameters: Reset2faForUserRequest, initOverrides?: RequestInit): Promise<void> {
        await this.reset2faForUserRaw(requestParameters, initOverrides);
    }

    /**
     * Unlocks the user if user is locked
     */
    async unlockUserRaw(requestParameters: UnlockUserRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling unlockUser.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/users/{userId}/unlock`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Unlocks the user if user is locked
     */
    async unlockUser(requestParameters: UnlockUserRequest, initOverrides?: RequestInit): Promise<void> {
        await this.unlockUserRaw(requestParameters, initOverrides);
    }

    /**
     * Update an existing user
     */
    async updateUserRaw(requestParameters: UpdateUserRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiUser>> {
        if (requestParameters.apiUser === null || requestParameters.apiUser === undefined) {
            throw new runtime.RequiredError('apiUser','Required parameter requestParameters.apiUser was null or undefined when calling updateUser.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/users`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ApiUserToJSON(requestParameters.apiUser),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiUserFromJSON(jsonValue));
    }

    /**
     * Update an existing user
     */
    async updateUser(requestParameters: UpdateUserRequest, initOverrides?: RequestInit): Promise<ApiUser> {
        const response = await this.updateUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
